import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import { TextField, MenuItem } from "@mui/material";
import { BorderLinearProgress, TopicsBox } from "./style";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ListSubheader from "@mui/material/ListSubheader";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import fractions from "../shared/images/fractions.png";

import geometry from "../shared/images/geometry.png";
import percentage from "../shared/images/percentage.png";
import measurement from "../shared/images/measurement.png";
import decimals from "../shared/images/decimals.png";
import numbers_to_10 from "../shared/images/numbers_to_10.png";
import numbers_to_20 from "../shared/images/numbers_to_20.png";
import numbers_to_100 from "../shared/images/numbers_to_100.png";
import numbers_to_40 from "../shared/images/numbers_to_40.png";
import length_and_measurement from "../shared/images/length_and_measurement.png";
import multiplication_and_division from "../shared/images/multiplication_and_division.png";
import shapes_and_patterns from "../shared/images/shapes_and_patterns.png";
import ordinal_numbers_and_positions from "../shared/images/ordinal_numbers_and_positions.png";
import addition_and_subtraction_within_10 from "../shared/images/addition_and_subtraction_within_10.png";
import addition_and_subtraction_within_20 from "../shared/images/addition_and_subtraction_within_20.png";
import money from "../shared/images/money.png";
import time from "../shared/images/time.png";
import graphs from "../shared/images/graphs.png";
import Carousel from "react-material-ui-carousel";
import { Paper, Button } from "@mui/material";
import PracticeIcon from "@mui/icons-material/School"; // Using an educational icon as a placeholder

type TopicsProps = {
  topics: any;
  level: number;
  selectTopic: Function;
};

const imageList = [
  {
    name: "fractions",
    img: fractions,
  },
  {
    name: "geometry",
    img: geometry,
  },
  {
    name: "percentage",
    img: percentage,
  },
  {
    name: "measurement",
    img: measurement,
  },
  {
    name: "decimals",
    img: decimals,
  },
  {
    name: "numbers_to_10",
    img: numbers_to_10,
  },
  {
    name: "numbers_to_20",
    img: numbers_to_20,
  },
  {
    name: "numbers_to_100",
    img: numbers_to_100,
  },
  {
    name: "numbers_to_40",
    img: numbers_to_40,
  },
  {
    name: "length_and_measurement",
    img: length_and_measurement,
  },
  {
    name: "multiplication_and_division",
    img: multiplication_and_division,
  },
  {
    name: "shapes_and_patterns",
    img: shapes_and_patterns,
  },
  {
    name: "ordinal_numbers_and_positions",
    img: ordinal_numbers_and_positions,
  },
  {
    name: "money",
    img: money,
  },
  {
    name: "time",
    img: time,
  },
  {
    name: "graphs",
    img: graphs,
  },
  {
    name: "addition_and_subtraction_within_10",
    img: addition_and_subtraction_within_10,
  },
  {
    name: "addition_and_subtraction_within_20",
    img: addition_and_subtraction_within_20,
  },
];

export const Topics = ({ topics, level, selectTopic }: TopicsProps) => {
  const topicsData =
    topics?.getTopics && topics?.getTopics?.length > 0
      ? topics?.getTopics?.map((topic: any, index: number) => {
          const topicName = topic?.name.toLowerCase().replaceAll(" ", "_");

          const imageFound = imageList.find(
            (image) => image.name === topicName
          );
          const image = imageFound ? imageFound.img : fractions;

          return { ...topic, img: image };
        })
      : [];

  const [topic, setTopic] = useState(topicsData[0]);
  const itemsPerSlide = 4;

  // Create an array of arrays to group items for each slide
  const groupedItems: any = [];
  for (let i = 0; i < topicsData.length; i += itemsPerSlide) {
    groupedItems.push(topicsData.slice(i, i + itemsPerSlide));
  }

  return (
    <TopicsBox>
      <Carousel
        next={(next: any, active: any) =>
          console.log(`we left ${active}, and are now at ${next}`)
        }
        prev={(prev: any, active: any) =>
          console.log(`we left ${active}, and are now at ${prev}`)
        }
      >
        {groupedItems.map((group: any, index: number) => (
          <Grid container spacing={4} key={index}>
            {group.map((item: any) => (
              <Grid>
                <Paper
                  sx={{ width: 270, height: 300 }}
                  onClick={() => {
                    selectTopic(item);
                  }}
                >
                  <div
                    style={{
                      // height: "50px",
                      // padding: "0.5rem",
                      paddingLeft: "1rem",
                      paddingTop: "2px",
                      backgroundColor: "#c0b8ff",
                      display: "flex",
                      // alignItems: "center",
                    }}
                  >
                    <PracticeIcon
                      sx={{
                        color: "#000000",
                        marginTop: "15px",
                        marginRight: "7px",
                      }}
                    />
                    <h3>{item.name}</h3>
                  </div>

                  <p
                    style={{
                      fontSize: ".895rem",
                      lineHeight: "1.25rem",
                      height: "7.5rem",
                      padding: "1rem",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.description}
                  </p>
                </Paper>
              </Grid>
            ))}
          </Grid>
        ))}
      </Carousel>
    </TopicsBox>
  );
};

export default Topics;
